export const isHovered = ({ value, hover }: { value: number; hover: number | null }) => {
  return !!(hover && value <= hover);
};
